import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const ALERT_RULES_QUERY_KEY = ["alert-rules"] as const;

type AlertRuleSortKey = components["schemas"]["AlertRuleSortKey"];
type SortOrder = components["schemas"]["SortOrder"];

export type ListAlertRulesQuery = {
  include_deleted?: boolean;
  sort_key?: AlertRuleSortKey;
  sort_order?: SortOrder;
  limit?: number;
  offset?: number;
};

export function useAlertRules(params: ListAlertRulesQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ALERT_RULES_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/alerts/rules", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list alert rules");
      }
      return data;
    },
  });
}
